/**
 * @desc 工厂直发散货订舱计划
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.cabinMasterFactoryScattered.exportCabinFactoryBookingPlanReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryScattered/exportCabinFactoryBookingPlanReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
